import { Component, OnInit } from "@angular/core";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Underline,
  Alignment,
  FontSize,
  FontFamily,
  FontColor,
  FontBackgroundColor,
  List,
  Link,
  Table,
  TableToolbar,
  TableProperties,
  TableCellProperties,
  TableColumnResize,
} from "ckeditor5";
import { ExamsService } from "../exams.service";
import { LoginService } from "../login.service";

export interface ClinicTemplate {
  ClinicTemplateID: number;
  GID: number;
  Title: string;
  TemplateContent: string;
  assignedUIDs: any[];
}

@Component({
    selector: "app-clinic-templates",
    templateUrl: "./clinic-templates.component.html",
    styleUrls: ["./clinic-templates.component.scss"],
    standalone: false
})
export class ClinicTemplatesComponent implements OnInit {
  public Editor = ClassicEditor;
  public editorConfig = {
    licenseKey: "GPL",
    language: { ui: "en", content: "he" },
    plugins: [
      Essentials, Paragraph, Bold, Italic, Underline, Alignment, FontSize,
      FontFamily, FontColor, FontBackgroundColor, List, Link, Table,
      TableToolbar, TableProperties, TableCellProperties, TableColumnResize,
    ],
    toolbar: [
      "undo", "redo", "|", "fontSize", "fontFamily", "fontColor",
      "fontBackgroundColor", "|", "bold", "italic", "underline", "|",
      "alignment", "|", "bulletedList", "numberedList", "|", "link", "insertTable",
    ],
    table: {
      contentToolbar: [
        "tableColumn", "tableRow", "mergeTableCells",
        "tableProperties", "tableCellProperties",
      ],
    },
  };

  tab: 'canvas' | 'builder' = 'canvas';
  templates: ClinicTemplate[] = [];
  doctors: any[] = [];
  title = "";
  content = "";
  selectedUIDs = new Set<any>();
  editingId: number | null = null;
  loading = false;
  showDeleteConfirm = false;
  templateToDelete: ClinicTemplate = null;
  autotextPopupTemplate: ClinicTemplate = null;

  constructor(public es: ExamsService, public ls: LoginService) {}

  ngOnInit() {
    this.ls.loginMissing();
    this.load();
    try {
      this.es.getAllPractitioners().subscribe(
        (data: any) => { this.doctors = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  load() {
    try {
      this.es.getClinicTemplates().subscribe(
        (data: any) => { this.templates = data || []; },
        (err) => { console.log(err); }
      );
    } catch (e) {
      console.log(e);
    }
  }

  toggleDoctor(uid: any) {
    if (this.selectedUIDs.has(uid)) this.selectedUIDs.delete(uid);
    else this.selectedUIDs.add(uid);
  }
  isSelected(uid: any): boolean {
    return this.selectedUIDs.has(uid);
  }

  resetForm() {
    this.editingId = null;
    this.title = "";
    this.content = "";
    this.selectedUIDs = new Set<any>();
  }

  save() {
    if (!this.title || this.loading) return;
    const body = {
      Title: this.title,
      TemplateContent: this.content,
      assignedUIDs: [...this.selectedUIDs],
    };
    this.loading = true;
    try {
      const obs = this.editingId
        ? this.es.updateClinicTemplate(this.editingId, body)
        : this.es.createClinicTemplate(body);
      obs.subscribe(
        (data: any) => { this.templates = data || []; this.resetForm(); this.loading = false; },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  edit(t: ClinicTemplate) {
    this.editingId = t.ClinicTemplateID;
    this.title = t.Title;
    this.content = t.TemplateContent || "";
    this.selectedUIDs = new Set<any>(t.assignedUIDs || []);
  }

  confirmDelete(t: ClinicTemplate) {
    this.templateToDelete = t;
    this.showDeleteConfirm = true;
  }
  cancelDelete() {
    this.templateToDelete = null;
    this.showDeleteConfirm = false;
  }
  doDelete() {
    if (!this.templateToDelete || this.loading) return;
    const id = this.templateToDelete.ClinicTemplateID;
    this.loading = true;
    try {
      this.es.deleteClinicTemplate(id).subscribe(
        (data: any) => {
          this.templates = data || [];
          this.showDeleteConfirm = false;
          this.templateToDelete = null;
          this.loading = false;
          if (this.editingId === id) this.resetForm();
        },
        (err) => { console.log(err); this.loading = false; }
      );
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  openAutotextPopup(t: ClinicTemplate) {
    this.autotextPopupTemplate = t;
  }
  closeAutotextPopup() {
    this.autotextPopupTemplate = null;
  }

  docLabel(uid: any): string {
    const d = this.doctors.find((x) => x.UID == uid);
    return d ? (d.Name || d.EngName || ("UID " + uid)) : ("UID " + uid);
  }
}
